<template>
    <div v-if="!loading">
        <div v-for="(item, index) in getByKey(this.parameters.key).data" :key="item.id" class="mt-4">
            <VideoItem :data="item" :index="index" v-model:active="active" />
        </div>

        <div class="flex flex-row gap-4 h-full mt-5">
            <div class="w-3/4 flex items-start justify-star">
                <div class="py-1 px-2 rounded rounded-md shadow border border-gray-500">
                    <a href="/videos" title="Sehen Sie hier alle Videos von HKCM">
                        <div class="flex flex-row group-hover:gap-3 transition-all ease-in-out duration-500 items-center gap-2">
                            {{ $t('news_all_videos') }}
                            <Icon type="ArrowRight" viewBox="0 0 29 21" width="18" height="10" class="fill-none stroke-current" />
                        </div>
                    </a>
                </div>
            </div>

            <div class="w-1/4 flex items-end justify-end">
                <Pagination :limit="-1" :data="getByKey(this.parameters.key)" @pagination-change-page="paginate" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
    data: () => ({
        loading: false,
        active: 0
    }),

    mounted() {
        this.indexSocialMedia();
    },

    props: ['parameters'],

    methods: {
        paginate(page) {
            this.loading = true;
            this.active = 0;
            this.indexSocialMedia({
                page: page
            });
        },
        async indexSocialMedia(params) {
            this.loading = true;
            let config = {
                params: this.parameters
            };

            _.merge(config.params, params);

            return await this.$store.dispatch('social_media/index', config).then(() => {
                this.loading = false;
            });
        }
    },

    computed: {
        ...mapGetters('social_media', ['getByKey'])
    }
};
</script>
